import { Controller } from 'stimulus';
import { debounce } from 'debounce';

/* Provides functionality for an inline form preview. The preview is intended to be an iframe of the content
   being edited that has a PreviewTargetController attached to it. As elements on the form change (you'll need to
   hook these up to hit the 'reload' action on this controller), the preview will be reloaded with the updated
   data. */
   
export default class PreviewController extends Controller {
  static targets = ["previewFrame", "previewTurboFrame", "form"]
  // Where the Turbo frame reloads from, when that isn't the page's own URL: a form that re-renders the edit
  // page at its PATCH URL after a failed save would otherwise reload from a URL that has no frame.
  static values = { reloadUrl: String }

  connect() {
    this.reload = debounce(this.reload, 200);
  }

  // Does nothing when neither target is in scope: a preview pane expanded over the page lives on <body>,
  // outside this controller, and refreshes itself when it is put back.
  reload() {
    if (this.hasPreviewTurboFrameTarget) {
      const originalTarget = this.formTarget.action;
      const originalMethod = this.formTarget.method;
      this.formTarget.dataset.turboFrame = this.previewTurboFrameTarget.id;
      this.formTarget.action = this.reloadUrlValue || window.location.href;
      this.formTarget.method = 'GET';
      this.formTarget.requestSubmit();
      window.requestAnimationFrame(() => {
        this.formTarget.dataset.turboFrame = null;
        this.formTarget.action = originalTarget;
        this.formTarget.method = originalMethod;
      });
    } else if (this.hasPreviewFrameTarget) {
      this.previewFrameTarget.contentWindow.postMessage({
        name: "supercast-preview-update",
        previewData: Object.fromEntries(new FormData(this.formTarget).entries())
      });
    }
  }

  changeSrc(event) {
    this.previewFrameTarget.src = event.target.dataset.previewSrcParam;
  }
}
